import { Pipe, PipeTransform } from '@angular/core';
import { OcrSearchResult } from './document-search-api.service';
import { WordRect } from '../preview/page-overlay/model';

@Pipe({
  name: 'toWordRect',
})
export class OcrSearchResultToWordRectPipe implements PipeTransform {
  transform(box: OcrSearchResult | undefined): WordRect {
    if (box === undefined) return { x: [0, 0], y: [0, 0] };
    return {
      x: [box.wordRectLeft, box.wordRectLeft + box.wordRectWidth],
      y: [box.wordRectTop, box.wordRectTop + box.wordRectHeight],
    };
  }
}
